import { render, staticRenderFns } from "./invite-earn.vue?vue&type=template&id=2830c54a&"
import script from "./invite-earn.vue?vue&type=script&lang=js&"
export * from "./invite-earn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports